export const ADMIN_TYPE = {
  SUPER_ADMIN: 'superadmin'
}



// WEBPACK FOOTER //
// ./src/enum/admin-type.enum.js